import React from 'react';

import { Button } from '@mui/material';

import {
  LOGIN_LINK_TEXT,
  SIGN_UP,
  SIGN_IN,
  SIGN_UP_CAPITAL_FIRST_LETTER,
  NOT_SELECTED_LOG_IN_SIGN_UP_FORM,
  SELECTED_LOG_IN_SIGN_UP_FORM,
} from '../../constants/Forms';

export const SignInOrLoginRowOnModal = ({ onButtonClick, currentForm }) => {
  const selectedStyleLogin =
    currentForm === LOGIN_LINK_TEXT
      ? SELECTED_LOG_IN_SIGN_UP_FORM
      : NOT_SELECTED_LOG_IN_SIGN_UP_FORM;
  const selectedStyleSignUp =
    currentForm === SIGN_UP ? SELECTED_LOG_IN_SIGN_UP_FORM : NOT_SELECTED_LOG_IN_SIGN_UP_FORM;

  return (
    <div className="modal-button-row-wrapper">
      <Button sx={{ ...selectedStyleLogin, mr: '4px' }} onClick={() => onButtonClick('/login')}>
        {SIGN_IN}
      </Button>
      <Button sx={{ ...selectedStyleSignUp, ml: '4px' }} onClick={() => onButtonClick('/signup')}>
        {SIGN_UP_CAPITAL_FIRST_LETTER}
      </Button>
    </div>
  );
};
